// Model.js
// -----------------------
// @module Case
define("Tavano.TTFormCoa.CoaForm.Model", ["Backbone", "Utils"], function(
    Backbone,
    Utils
) {
    "use strict";

    // @class Case.Fields.Model @extends Backbone.Model
    return Backbone.Model.extend({

        
        //@property {String} urlRoot
        urlRoot: Utils.getAbsoluteUrl(
            getExtensionAssetsPath(
                "services/CoaForm.Service.ss"
            )
        ),
        validation: {
            ordernumber: {
                required: true,
                msg: _('Order Number is required').translate()
            },
            partnumber: {
                required: true,
                msg: _('Part Number is required').translate()
            },
            email: {
                required: true,
                pattern: 'email',
                msg: _('Valid Email is required').translate()
            },
            lotnumber: {
                required: true,
                msg: _('Lot Number is required').translate()
            },
        }
});
});
